'use strict';
import { gsap } from 'gsap';
// プログレスバー
export const initProgressBar = () => {
  gsap.to('progress', {
    value: 100,
    ease: 'none',
    scrollTrigger: { scrub: 0.3 },
  });
};
